// luxury-vinyl products (4 items)
export const productsLuxuryVinyl = [
  {
    id: 1,
    slug: "nature-view-rustique-7x48",
    name: "Nature View™ Style Rustique",
    variant: "7\" x 48\" Planks",
    type: "Luxury Vinyl Plank",
    category: "Luxury Vinyl",

    categoryId: "luxury-vinyl",    productSheetPdf: "/Assets/pdf/nature-view-rustique-7x48/PS_ISS_NVR7x48.pdf",
    techSpecsPdf: "/Assets/pdf/nature-view-rustique-7x48/PS_TechSpecs_NVR7x48_40MIL.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 21,
    sizeFormat: "Planks",
    zones: [3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["earth-tones"],
      patterns: ["solid", "textured", "wood-look"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/7in/7x48_thumbnail.jpg",
    heroImage: "/Assets/images/products/7in/7x48_hero-img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/floorscore-scs.svg", alt: "FloorScore SCS Certified" },
      { src: "/Assets/icons/attributes/white-sticker.svg", alt: "Certified" }
    ],
    comparisonSpecs: {
      material: "Class III Printed Film Vinyl Plank; 1x Coated Registered Embossed Surface",
      construction: "40mil Wear Layer",
      backing: "Extruded Vinyl Core Layers",
      thickness: "0.125 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue-down",
      recommendedZone: "Zone 3",
      bestUseCase: "Main flooring spaces"
    },
    keyFeatures: [
      "Natural look and feel",
      "Designed for heavy traffic",
      "Antibacterial"
    ],
    gallery: [
      "/Assets/images/products/lvt-7x48/grocery_lvp.jpg",
      "/Assets/images/products/lvt-7x48/vet_lvp.jpg",
      "/Assets/images/products/lvt-7x48/office_lvp.jpg",
      "/Assets/images/new-product-imgs/NVR-7/7in_05.jpg",
      "/Assets/images/products/lvt-7x48/jewelry_store.jpg",
      "/Assets/images/products/lvt-7x48/jewelry_store2.jpg",
      "/Assets/images/products/lvt-7x48/generic_lvt.jpg",
      "/Assets/images/products/lvt-7x48/pro_shop.jpg"
    ],
    swatchesLabel: "Four-Up Tile Sets",
    swatches: [
      { name: "African Blackwood", image: "/Assets/images/products/7in/AfricanBlackwood.jpg" },
      { name: "Anchor Grey", image: "/Assets/images/products/7in/AnchorGrey.jpg" },
      { name: "Antique Brown", image: "/Assets/images/products/7in/AntiqueBrown.jpg" },
      { name: "Ashwood Grey", image: "/Assets/images/products/7in/AshwoodGrey.jpg" },
      { name: "Canyon Dust Cross Cut", image: "/Assets/images/products/7in/CanyonDustCrossCut.jpg" },
      { name: "Cape Cod Grey", image: "/Assets/images/products/7in/CapeCodGrey.jpg" },
      { name: "Dove", image: "/Assets/images/products/7in/Dove.jpg" },
      { name: "Harvest Oak", image: "/Assets/images/products/7in/HarvestOak.jpg" },
      { name: "Toasted Oak", image: "/Assets/images/products/7in-lvt/swatches/Hickory_swatch.jpg" },
      { name: "Honduran Rosewood", image: "/Assets/images/products/7in/HonduranRosewood.jpg" },
      { name: "Ice Frost Oak", image: "/Assets/images/products/7in/IceFrostOak.jpg" },
      { name: "Neutral Beige", image: "/Assets/images/products/7in-lvt/swatches/NeutralBeige_swatch.jpg" },
      { name: "Oak Barrel", image: "/Assets/images/products/7in/OakBarrel.jpg" },
      { name: "Silver Sand", image: "/Assets/images/products/7in/SilverSand.jpg" },
      { name: "Smoked Walnut", image: "/Assets/images/products/7in/SmokedWalnut.jpg" },
      { name: "Sterling Ash", image: "/Assets/images/products/7in-lvt/swatches/SterlingAsh_swatch.jpg" },
      { name: "Sundried Teak", image: "/Assets/images/products/7in/SundriedTeak.jpg" },
      { name: "Weathered Ash", image: "/Assets/images/products/7in-lvt/swatches/WeatheredAsh_swatch.jpg" },
      { name: "Wheatfields", image: "/Assets/images/products/7in/Wheatfields.jpg" },
      { name: "Whiskey Cross Cut", image: "/Assets/images/products/7in/WhiskeyCrossCut.jpg" },
      { name: "Windswept Beige", image: "/Assets/images/products/7in/WindsweptBeige.jpg" }
    ],
    isPlaceholder: false,
    warranty: "21 year warranty",
    description: [
      "You want the warmth and character of real wood, but without the constant maintenance, damage, or downtime that comes with it. Nature View™ Style Rustique 7\" x 48\", delivers the natural look you love with the commercial-grade performance your space demands.",
      "Designed for space with heavy traffic, this luxury vinyl plank helps your floors stay beautiful, clean, and dependable day after day.",
      "With Nature View™ Style Rustique 7\" x 48\", you get the beauty of wood, the strength of commercial performance, and the peace of mind that comes from flooring built to last."
    ],
    features: [
      "Natural look and feel",
      "Designed for heavy traffic",
      "Antibacterial"
    ],
    specifications: {
      overallThickness: "3.175mm | 0.125\"",
      wearLayerThickness: "1.0mm | 40mil",
      plankSize: "7\" x 48\"",
      staticLoad: "2000 psi (ASTM F970 - Modified)"
    },
    singlePlankPreviews: [
      { name: "African Blackwood", image: "/Assets/images/products/lvt-previews/7x48/half/African-Blackwood.jpg" },
      { name: "Anchor Grey", image: "/Assets/images/products/lvt-previews/7x48/half/Anchor-Grey.jpg" },
      { name: "Antique Brown", image: "/Assets/images/products/lvt-previews/7x48/half/Antique-Brown.jpg" },
      { name: "Ashwood Grey", image: "/Assets/images/products/lvt-previews/7x48/half/Ashwood-Grey.png" },
      { name: "Canyon Dust Cross Cut", image: "/Assets/images/products/lvt-previews/7x48/half/Canyon-Dust-Cross-Cut.jpg" },
      { name: "Cape Cod Grey", image: "/Assets/images/products/lvt-previews/7x48/half/Cape-Cod-Grey.jpg" },
      { name: "Dove", image: "/Assets/images/products/lvt-previews/7x48/half/Dove.jpg" },
      { name: "Harvest Oak", image: "/Assets/images/products/lvt-previews/7x48/half/Harvest-Oak.png" },
      { name: "Toasted Oak", image: "/Assets/images/products/lvt-previews/7x48/half/Toasted-Oak.jpg" },
      { name: "Honduran Rosewood", image: "/Assets/images/products/lvt-previews/7x48/half/Honduran-Rosewood.jpg" },
      { name: "Ice Frost Oak", image: "/Assets/images/products/lvt-previews/7x48/half/Ice-Frost-Oak.jpg" },
      { name: "Neutral Beige", image: "/Assets/images/products/lvt-previews/7x48/half/Neutral-Beige.jpg" },
      { name: "Oak Barrel", image: "/Assets/images/products/lvt-previews/7x48/half/Oak-Barrel.jpg" },
      { name: "Silver Sand", image: "/Assets/images/products/lvt-previews/7x48/half/Silver-Sand.jpg" },
      { name: "Smoked Walnut", image: "/Assets/images/products/lvt-previews/7x48/half/Smoked-Walnut.jpg" },
      { name: "Sterling Ash", image: "/Assets/images/products/lvt-previews/7x48/half/Sterling-Ash.jpg" },
      { name: "Sundried Teak", image: "/Assets/images/products/lvt-previews/7x48/half/Sundried-Teak.jpg" },
      { name: "Weathered Cedar", image: "/Assets/images/products/lvt-previews/7x48/half/Weathered-Cedar.jpg" },
      { name: "Wheatfields", image: "/Assets/images/products/lvt-previews/7x48/half/Wheatfields.jpg" },
      { name: "Whiskey Cross Cut", image: "/Assets/images/products/lvt-previews/7x48/half/Whiskey-Cross-Cut.jpg" },
      { name: "Windswept Beige", image: "/Assets/images/products/lvt-previews/7x48/half/Windswept-Beige.jpg" }
    ]
  },
  {
    id: 2,
    slug: "nature-view-rustique-6x36",
    name: "Nature View™ Style Rustique",
    variant: "6\" x 36\" Planks",
    type: "Luxury Vinyl Plank",
    category: "Luxury Vinyl",

    categoryId: "luxury-vinyl",    productSheetPdf: "/Assets/pdf/nature-view-rustique-6x36/PS_ISS_NVR6x36.pdf",
    techSpecsPdf: "/Assets/pdf/nature-view-rustique-6x36/PS_TechSpecs_NVR6x36.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 1,
    sizeFormat: "Planks",
    zones: [3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["earth-tones"],
      patterns: ["solid", "textured", "wood-look"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/Nature-View-6x36/weatheredbarn.jpg",
    heroImage: "/Assets/images/products/6in/6x36_hero-img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/floorscore-scs.svg", alt: "FloorScore SCS Certified" },
      { src: "/Assets/icons/attributes/white-sticker.svg", alt: "Certified" }
    ],
    comparisonSpecs: {
      material: "Class III Printed Film Vinyl Plank; 1x Coated Registered Embossed Surface",
      construction: "40mil Wear Layer",
      backing: "Extruded Vinyl Core Layers",
      thickness: "0.125 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue-down",
      recommendedZone: "Zone 3",
      bestUseCase: "Main flooring spaces"
    },
    keyFeatures: [
      "Natural look and feel",
      "Designed for heavy traffic",
      "Antibacterial"
    ],
    gallery: [
      "/Assets/images/products/6in/6x36_hero-img.jpg",
      "/Assets/images/products/Nature-View-6x36/weatheredbarn_02.jpg",
      "/Assets/images/products/lvt-6x36/ace_paint_studio.jpg",
      "/Assets/images/products/lvt-6x36/post_office_mailboxes.jpg",
      "/Assets/images/products/lvt-6x36/caribou_coffee_lvt.jpg",
      "/Assets/images/products/lvt-6x36/post_office_counter_lvt.jpg"
    ],
    swatchesLabel: "Four-Up Tile Sets",
    swatches: [
      { name: "Weathered Barn", image: "/Assets/images/products/6in/LVP_NVR_9.5x9_WeatheredBarn.jpg" }
    ],
    isPlaceholder: false,
    warranty: "21 year warranty",
    description: [
      "You want the warmth and character of real wood, but without the constant maintenance, damage, or downtime that comes with it. Nature View™ Style Rustique delivers the natural look you love with the commercial-grade performance your space demands.",
      "Designed for space with heavy traffic, this luxury vinyl plank helps your floors stay beautiful, clean, and dependable day after day.",
      "With Nature View™ Style Rustique 6\" x 36\", you get the beauty of wood, the strength of commercial performance, and the peace of mind that comes from flooring built to last."
    ],
    features: [
      "Natural look and feel",
      "Designed for heavy traffic",
      "Antibacterial"
    ],
    specifications: {
      overallThickness: "3.175mm | 0.125\"",
      wearLayerThickness: "1.0mm | 40mil",
      plankSize: "6\" x 36\"",
      staticLoad: "2000 psi (ASTM F970 - Modified)"
    },
    singlePlankPreviews: [
      { name: "Weathered Barn", image: "/Assets/images/products/lvt-previews/6x36/WeatheredBarn_6x36_half.jpg" }
    ]
  },
  {
    id: 3,
    slug: "nature-view-rustique-18x18",
    name: "Nature View™ Style Rustique",
    variant: "18\" x 18\" Tiles",
    type: "Luxury Vinyl Tile",
    category: "Luxury Vinyl",

    categoryId: "luxury-vinyl",    productSheetPdf: "/Assets/pdf/nature-view-rustique-18x18/PS_ISS_NVR18x18.pdf",
    techSpecsPdf: "/Assets/pdf/nature-view-rustique-18x18/PS_TechSpecs_NVR18x18.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 11,
    sizeFormat: "Tiles",
    zones: [3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["earth-tones"],
      patterns: ["solid", "textured", "stone-look"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/18in/18x18_thumbnail.jpeg",
    heroImage: "/Assets/images/products/18in/18x18_hero-img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/floorscore-scs.svg", alt: "FloorScore SCS Certified" },
      { src: "/Assets/icons/attributes/white-sticker.svg", alt: "Certified" }
    ],
    comparisonSpecs: {
      material: "Class III Printed Film Vinyl Plank; 1x Coated Registered Embossed Surface",
      construction: "40mil Wear Layer",
      backing: "Extruded Vinyl Core Layers",
      thickness: "0.125 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue-down",
      recommendedZone: "Zone 3",
      bestUseCase: "Main flooring spaces"
    },
    keyFeatures: [
      "Natural look and feel",
      "Designed for heavy traffic",
      "Antibacterial"
    ],
    gallery: [
      "/Assets/images/products/18in/18x18_hero-img.jpg",
      "/Assets/images/products/18in/grocery_store_18x18.jpg",
      "/Assets/images/new-product-imgs/NVR-18/18in_02.jpeg",
      "/Assets/images/new-product-imgs/NVR-18/18in_03.jpg",
      "/Assets/images/new-product-imgs/NVR-18/18in_04.jpg",
      "/Assets/images/new-product-imgs/NVR-18/18in_05.jpg"
    ],
    swatchesLabel: "Four-Up Tile Sets",
    swatches: [
      { name: "Foundation Grey", image: "/Assets/images/products/lvt-previews/18x18/FoundationGrey_4Tile_18x18.jpg" },
      { name: "Limestone", image: "/Assets/images/products/18in/Limestone_4Tile_18x18.jpg" },
      { name: "Metallic Delight", image: "/Assets/images/products/18in/MetallicDelight_4Tile_18x18.jpg" },
      { name: "Mink Slate", image: "/Assets/images/products/18in/MinkSlate_4Tile_18x18.jpg" },
      { name: "Morning Fog", image: "/Assets/images/products/lvt-previews/18x18/MorningFog_4Tile_18x18.jpg" },
      { name: "Neutral Ground", image: "/Assets/images/products/lvt-previews/18x18/NeutralGround_4Tile_18x18.jpg" },
      { name: "Ostrich Grey", image: "/Assets/images/products/18in/OstrichGrey_4Tile_18x18.jpg" },
      { name: "Oxidized Pewter", image: "/Assets/images/products/18in/OxidizedPewter_4Tile_18x18.jpg" },
      { name: "Oyster", image: "/Assets/images/products/18in/Oyster_4Tile_18x18.jpg" },
      { name: "River Rock", image: "/Assets/images/products/18in/RiverRock_4Tile_18x18.jpg" },
      { name: "Silver Knight", image: "/Assets/images/products/18in/SilverKnight_4Tile_18x18.jpg" },
      { name: "Titanium", image: "/Assets/images/products/18in/Titanium_4Tile_18x18.jpg" },
      { name: "Toasted Almond", image: "/Assets/images/products/18in/ToastedAlmond_4Tile_18x18.jpg" },
      { name: "Urban Grey", image: "/Assets/images/products/18in/UrbanGrey_4Tile_18x18.jpg" }
    ],
    isPlaceholder: false,
    warranty: "21 year warranty",
    description: [
      "Nature View™ Style Rustique 18\" x 18\" Luxury Vinyl Tile is available in 11 distinctive styles, giving you the natural stone look needed to elevate any design, without the limitations of real stone. Built for performance and ease, it's designed to look great and hold up in demanding environments.",
      "With Nature View™ Style Rustique, you get the beauty of wood, the strength of commercial performance, and the peace of mind that comes from flooring built to last."
    ],
    features: [
      "Natural look and feel",
      "Designed for heavy traffic",
      "Antibacterial"
    ],
    specifications: {
      overallThickness: "3.175mm | 0.125\"",
      wearLayerThickness: "1.0mm | 40mil",
      tileSize: "18\" x 18\"",
      staticLoad: "2000 psi (ASTM F970 - Modified)"
    },
    singleTilePreviews: [
      { name: "Foundation Grey", image: "/Assets/images/products/lvt-previews/18x18/Cement_NVT2302.jpg" },
      { name: "Limestone", image: "/Assets/images/products/lvt-previews/18x18/Limestone_NV3061_18x18_3.jpg" },
      { name: "Metallic Delight", image: "/Assets/images/products/lvt-previews/18x18/Metallic_Delight_NVC2893_18x18_2.jpg" },
      { name: "Mink Slate", image: "/Assets/images/products/lvt-previews/18x18/Mink_Slate_VNHT403_18x18_2.jpg" },
      { name: "Morning Fog", image: "/Assets/images/products/lvt-previews/18x18/MorningFog_SS3479_4.jpg" },
      { name: "Neutral Ground", image: "/Assets/images/products/18in/Single_NeutralGround.jpg" },
      { name: "Ostrich Grey", image: "/Assets/images/products/lvt-previews/18x18/Ostrich_Grey_NVC3879_18x18_2.jpg" },
      { name: "Oxidized Pewter", image: "/Assets/images/products/lvt-previews/18x18/Oxidized_Pewter_NVC1737_18x18_2.jpg" },
      { name: "Oyster", image: "/Assets/images/products/lvt-previews/18x18/Oyster_NVC1738_2.jpg" },
      { name: "Silver Knight", image: "/Assets/images/products/lvt-previews/18x18/SilverKnight_NVC3744_4.jpg" },
      { name: "Titanium", image: "/Assets/images/products/lvt-previews/18x18/Titanium_NVC3724_1.jpg" },
      { name: "Toasted Almond", image: "/Assets/images/products/lvt-previews/18x18/ToastedAlmond_NVC1739_1.jpg" },
      { name: "Urban Grey", image: "/Assets/images/products/lvt-previews/18x18/UrbanGrey_NVC3342_1.jpg" },
      { name: "River Rock", image: "/Assets/images/products/lvt-previews/18x18/v2_River_Rock_NVC2891_1.jpg" }
    ]
  },
  {
    id: 17,
    slug: "nature-view-18x36-lvt",
    name: "Nature View™ Style Rustique",
    variant: "18\" x 36\" Tiles",
    type: "Luxury Vinyl Tile",
    category: "Luxury Vinyl",

    categoryId: "luxury-vinyl",    productSheetPdf: "/Assets/pdf/nature-view-18x36-lvt/PS_ISS_NVR18x36.pdf",
    techSpecsPdf: "/Assets/pdf/nature-view-18x36-lvt/PS_TechSpecs_NVR18x36.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 5,
    sizeFormat: "Tiles",
    zones: [3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["earth-tones"],
      patterns: ["solid", "textured", "stone-look"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/18x36-lvt/gallery/reception_concrete.jpg",
    heroImage: "/Assets/images/products/18x36-lvt/gallery/reception_concrete.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/floorscore-scs.svg", alt: "FloorScore SCS Certified" }
    ],
    comparisonSpecs: {
      material: "Class III Printed Film Vinyl Plank; 1x Coated Registered Embossed Surface",
      construction: "40mil Wear Layer",
      backing: "Extruded Vinyl Core Layers",
      thickness: "0.125 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue-down",
      recommendedZone: "Zone 3",
      bestUseCase: "Main flooring spaces"
    },
    keyFeatures: [
      "Natural look and feel",
      "Designed for heavy traffic",
      "Antibacterial"
    ],
    gallery: [
      "/Assets/images/products/18x36-lvt/gallery/reception_concrete.jpg",
      "/Assets/images/products/18x36-lvt/gallery/warehouse_install.jpg",
      "/Assets/images/products/18x36-lvt/LVT_18x36_-(2).jpg",
      "/Assets/images/products/18x36-lvt/gallery/office_openspace.jpg",
      "/Assets/images/products/18x36-lvt/gallery/18x36_office_lounge.jpg",
      "/Assets/images/products/18x36-lvt/gallery/18x36_d.jpg",
      "/Assets/images/products/18x36-lvt/gallery/18x36_restaurant.jpg"
    ],
    swatches: [],
    fourUpSwatches: [
      { name: "Silver Knight", image: "/Assets/images/products/18x36-lvt/Swatches/Four-Tile-Setup/SilverKnight_4Tile_18x36.jpg" },
      { name: "Titanium", image: "/Assets/images/products/18x36-lvt/Swatches/Four-Tile-Setup/Titanium_4Tile_18x36.jpg" },
      { name: "Foundation Grey", image: "/Assets/images/products/18x36-lvt/Swatches/FourUp/FoundationGrey_four-up.jpg" },
      { name: "Morning Fog", image: "/Assets/images/products/18x36-lvt/Swatches/FourUp/MorningFog_four-up.jpg" },
      { name: "Neutral Ground", image: "/Assets/images/products/18x36-lvt/Swatches/FourUp/NeutralGround_four-up.jpg" }
    ],
    isPlaceholder: false,
    warranty: "21-year warranty",
    description: [
      "If you want to create a space that feels refined and timeless, you need flooring that delivers the beauty of natural stone, without the cost, weight, and maintenance challenges. The problem is that real stone can be expensive, difficult to install, and hard to maintain in high-traffic environments.",
      "Nature View™ Style Rustique Luxury Vinyl Tile gives you the authentic stone look with durability and easy care you need to design with confidence."
    ],
    features: [
      "Natural look and feel",
      "Designed for heavy traffic",
      "Antibacterial"
    ],
    specifications: {
      overallThickness: "3.175mm | 0.125\"",
      wearLayerThickness: "1.0mm | 40mil",
      tileSize: "18\" x 36\"",
      staticLoad: "2000 psi (ASTM F970 - Modified)"
    },
    singleTilePreviews: [
      { name: "Silver Knight", image: "/Assets/images/products/lvt-previews/18x36/SilverKnight_18x36.jpg" },
      { name: "Titanium", image: "/Assets/images/products/lvt-previews/18x36/Titanium_18x36.jpg" },
      { name: "Foundation Grey", image: "/Assets/images/products/18x36-lvt/Swatches/Single/FoundationGrey_single.jpg" },
      { name: "Morning Fog", image: "/Assets/images/products/18x36-lvt/Swatches/Single/MorningFog_single.jpg" },
      { name: "Neutral Ground", image: "/Assets/images/products/18x36-lvt/Swatches/Single/NeutralGround_single.jpg" }
    ]
  },
];
